import React, { useEffect, useState, useMemo } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import '@laramie/ui/dist/components/controls/UsuariosModal/index.css';
import { func, array, bool } from 'prop-types';
import { Modal, TableCustom, InputWithEnterEvent, AdvancedSearch } from '../../common';
import { ServerRequest } from '../../../utils/apiweb';
import { CloneObject } from '../../../utils/helpers';
import { APIS } from '../../../config/apis';

const UsuariosModal = (props) => {

  const [usuarios, setUsuarios] = useState([]);
  const [filterInputs, setFilterInputs] = useState({});
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const defaultColumns = [
    { Header: '', Cell: null, id:'select', accessor: 'id', width: '5%', disableSortBy: true },
    { Header: 'Usuario/a', accessor: 'codigo' },
    { Header: 'Nombre y apellido', accessor: 'nombreApellido' },
    { Header: 'E-Mail', accessor: 'email' }
  ];

  const handleClickSelect = (row) => {
    props.onConfirm(row.id, CloneObject(row));
  };

  const cellS = (props) => (
    <div className='action'>
      <div onClick={() => handleClickSelect(props.row.original)} className="link">
        <span className="material-symbols-outlined" title="Seleccionar">west</span>
      </div>
    </div>
  );

  const tableColumns = useMemo(() => {
    if (props.columns && props.columns.length > 0) {
      return defaultColumns.map((col, index) => {
        if (index === 0) return { ...col, Cell: cellS };
        const customCol = props.columns.find(c => c.accessor === col.accessor);
        return customCol ? { ...col, Header: customCol.Header } : col;
      });
    }
    return defaultColumns.map((col, index) => {
      if (index === 0) return { ...col, Cell: cellS };
      return col;
    });
  }, [props.columns]);

  const shouldUseWhitelist = () => {
    return props.idWhitelist && props.idWhitelist.length > 0;
  }

  const onSearch = () => {
    setFilters(filterInputs);

    if (shouldUseWhitelist() && props.idWhitelist.length < 1) {
      setUsuarios([]);
      return;
    }

    setLoading(true);

    const callbackSuccess = (response) => {
      response.json()
      .then((data) => {
        setUsuarios(data);
        setLoading(false);
      })
      .catch((error) => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
        setLoading(false);
      });
    };

    const callbackError = (error) => {
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message);
      setLoading(false);
    };

    if (shouldUseWhitelist()) {
      ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.USUARIO,
        `/ids`,
        { ids: props.idWhitelist },
        callbackSuccess,
        (res) => res.json().then((error) => ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message)),
        callbackError
      );
    } else {
      ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.USUARIO,
        null,
        null,
        callbackSuccess,
        (res) => res.json().then((error) => ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message)),
        callbackError
      );
    }
  };

  const filteredUsuarios = useMemo(() => {
    if (!filters.codigo && !filters.nombreApellido) {
      return usuarios;
    }
    const result = [];
    usuarios.forEach(item => {
      const matchCodigo = !filters.codigo || (item.codigo && item.codigo.toLowerCase().includes(filters.codigo.toLowerCase()));
      const matchNombre = !filters.nombreApellido || (item.nombreApellido && item.nombreApellido.toLowerCase().includes(filters.nombreApellido.toLowerCase()));
      if (matchCodigo && matchNombre) {
        result.push(item);
      }
    });
    return result;
  }, [usuarios, filters]);

  const labels = useMemo(() => {
    const result = [];
    if (filters.nombreApellido) result.push({ title: 'Nombre', value: filters.nombreApellido });
    if (filters.codigo) result.push({ title: 'Código', value: filters.codigo });
    return result;
  }, [filters]);

  const handleClickWithoutSelection = () => {
    props.onConfirm(0, null);
  };

  useEffect(() => {
    onSearch();
  }, [props.idWhitelist]);

  return (
    <Modal
      onEscape={props.onDismiss}
      show
      title="Selección de usuario/a"
      body={
        <div>
          {(props.showAdvancedSearch !== false) && (
            <AdvancedSearch labels={labels} onSearch={onSearch}>
              <div className='row form-basic'>
                <div className="col-12 col-md-6 col-lg-6">
                  <label htmlFor="nombreApellido" className="form-label">Nombre</label>
                  <InputWithEnterEvent
                    name="nombreApellido"
                    type="text"
                    placeholder=""
                    className="form-control"
                    value={filterInputs.nombreApellido}
                    onChange={({ target }) => setFilterInputs({...filterInputs, nombreApellido: target.value})}
                    onEnter={onSearch}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <label htmlFor="codigo" className="form-label">Código</label>
                  <InputWithEnterEvent
                    name="codigo"
                    type="text"
                    placeholder=""
                    className="form-control"
                    value={filterInputs.codigo}
                    onChange={({ target }) => setFilterInputs({...filterInputs, codigo: target.value})}
                    onEnter={onSearch}
                  />
                </div>
              </div>
            </AdvancedSearch>
          )}

          <TableCustom
            className='TableCustomBase m-top-15'
            data={filteredUsuarios}
            columns={tableColumns}
            onClickRow={(row) => handleClickSelect(row.original)}
            showDownloadCSV={false}
            showFilterGlobal={false}
            loading={loading}
          />
        </div>
      }
      footer={
        <div className="width-100p f-align">
          {(props.showWithoutSelection !== false) && (
            <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={handleClickWithoutSelection}>Sin selección</button>
          )}
          <button className="btn back-button float-start" data-dismiss="modal" onClick={props.onDismiss}>Volver</button>
        </div>
      }
    />
  );
}

UsuariosModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  idWhitelist: array,
  filter: func,
  columns: array,
  showWithoutSelection: bool,
  showAdvancedSearch: bool
};

UsuariosModal.defaultProps = {
  showWithoutSelection: true,
  showAdvancedSearch: true
};

export default UsuariosModal;
